export default __webpack_public_path__ + "static/pattern-2-efa205b180b85e9c8a6a1a71689023fb.png";